 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Categories":"Categories","CommandAdd~FastSale~SaleIndex":"CommandAdd~FastSale~SaleIndex","CommandAdd":"CommandAdd","CommandIndex~DocumentCreate~DocumentIndex~FastSale~Note~SaleIndex~payments~salesBySeller":"CommandIndex~DocumentCreate~DocumentIndex~FastSale~Note~SaleIndex~payments~salesBySeller","CommandIndex":"CommandIndex","CommandsReports~DocumentsReports~Inventories~InventoryHistories~salesBySeller":"CommandsReports~DocumentsReports~Inventories~InventoryHistories~salesBySeller","salesBySeller":"salesBySeller","DocumentCreate~FastSale~People~SaleIndex~payments":"DocumentCreate~FastSale~People~SaleIndex~payments","FastSale":"FastSale","Orders~OrdersCreate~SaleIndex":"Orders~OrdersCreate~SaleIndex","SaleIndex":"SaleIndex","DocumentCreate":"DocumentCreate","payments":"payments","DocumentIndex":"DocumentIndex","Note":"Note","CommandZones":"CommandZones","CommandsReports":"CommandsReports","DocumentsReports":"DocumentsReports","Inventories":"Inventories","InventoryHistories":"InventoryHistories","Configurations":"Configurations","Correlatives":"Correlatives","CulqiTokens":"CulqiTokens","DistributionAreas":"DistributionAreas","People":"People","Establishments":"Establishments","Ingredients":"Ingredients","Items":"Items","Login":"Login","Movements":"Movements","Orders":"Orders","OrdersCreate":"OrdersCreate","Permissions":"Permissions","Recipes":"Recipes","Reports":"Reports","Roles":"Roles","SalesReceivables":"SalesReceivables","Salons":"Salons","Summaries":"Summaries","Tables":"Tables","UnitTypes":"UnitTypes","Users":"Users","Voided":"Voided","Waiters":"Waiters","cashes":"cashes","deliveryPayment":"deliveryPayment","histories":"histories","openings":"openings","tasks":"tasks"}[chunkId]||chunkId) + "." + {"Categories":"9c00fee5","CommandAdd~FastSale~SaleIndex":"c75b3557","CommandAdd":"b1d9c54f","CommandIndex~DocumentCreate~DocumentIndex~FastSale~Note~SaleIndex~payments~salesBySeller":"838ecc05","CommandIndex":"dd2be486","CommandsReports~DocumentsReports~Inventories~InventoryHistories~salesBySeller":"c8d01d20","salesBySeller":"456238ba","DocumentCreate~FastSale~People~SaleIndex~payments":"d95e4db6","FastSale":"aef64f1a","Orders~OrdersCreate~SaleIndex":"0d7cbf34","SaleIndex":"7d5a5e8b","DocumentCreate":"0c4e3ab8","payments":"1623e9a2","DocumentIndex":"c6d12f43","Note":"e20fc12a","CommandZones":"dad9cb61","CommandsReports":"cd374507","DocumentsReports":"b49a4f34","Inventories":"a8856521","InventoryHistories":"18f91ef6","Configurations":"3b9fa8e8","Correlatives":"dd49420e","CulqiTokens":"782601de","DistributionAreas":"37dc1277","People":"2597bc3c","Establishments":"ecd975d8","Ingredients":"c620c49e","Items":"fb38cf0b","Login":"2b6fde74","Movements":"23a23e2d","Orders":"307b9190","OrdersCreate":"9a80130f","Permissions":"40044093","Recipes":"6d0c6f06","Reports":"d19c8e11","Roles":"7b05fd86","SalesReceivables":"1a6b58b7","Salons":"44cfe83d","Summaries":"f80ad501","Tables":"1bce8f2d","UnitTypes":"3969dfbe","Users":"bd068887","Voided":"f8550620","Waiters":"287f2257","cashes":"cf4f5860","chunk-2d0e5e97":"69c47247","deliveryPayment":"fbbec4a8","histories":"aa8bf315","openings":"08aca51c","tasks":"1fdd4539"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Categories":1,"CommandAdd~FastSale~SaleIndex":1,"CommandIndex":1,"SaleIndex":1,"DocumentIndex":1,"CommandZones":1,"Configurations":1,"Correlatives":1,"People":1,"Establishments":1,"Ingredients":1,"Login":1,"Orders":1,"Permissions":1,"Roles":1,"Salons":1,"Tables":1,"UnitTypes":1,"Users":1,"Voided":1,"Waiters":1,"cashes":1,"histories":1,"tasks":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Categories":"Categories","CommandAdd~FastSale~SaleIndex":"CommandAdd~FastSale~SaleIndex","CommandAdd":"CommandAdd","CommandIndex~DocumentCreate~DocumentIndex~FastSale~Note~SaleIndex~payments~salesBySeller":"CommandIndex~DocumentCreate~DocumentIndex~FastSale~Note~SaleIndex~payments~salesBySeller","CommandIndex":"CommandIndex","CommandsReports~DocumentsReports~Inventories~InventoryHistories~salesBySeller":"CommandsReports~DocumentsReports~Inventories~InventoryHistories~salesBySeller","salesBySeller":"salesBySeller","DocumentCreate~FastSale~People~SaleIndex~payments":"DocumentCreate~FastSale~People~SaleIndex~payments","FastSale":"FastSale","Orders~OrdersCreate~SaleIndex":"Orders~OrdersCreate~SaleIndex","SaleIndex":"SaleIndex","DocumentCreate":"DocumentCreate","payments":"payments","DocumentIndex":"DocumentIndex","Note":"Note","CommandZones":"CommandZones","CommandsReports":"CommandsReports","DocumentsReports":"DocumentsReports","Inventories":"Inventories","InventoryHistories":"InventoryHistories","Configurations":"Configurations","Correlatives":"Correlatives","CulqiTokens":"CulqiTokens","DistributionAreas":"DistributionAreas","People":"People","Establishments":"Establishments","Ingredients":"Ingredients","Items":"Items","Login":"Login","Movements":"Movements","Orders":"Orders","OrdersCreate":"OrdersCreate","Permissions":"Permissions","Recipes":"Recipes","Reports":"Reports","Roles":"Roles","SalesReceivables":"SalesReceivables","Salons":"Salons","Summaries":"Summaries","Tables":"Tables","UnitTypes":"UnitTypes","Users":"Users","Voided":"Voided","Waiters":"Waiters","cashes":"cashes","deliveryPayment":"deliveryPayment","histories":"histories","openings":"openings","tasks":"tasks"}[chunkId]||chunkId) + "." + {"Categories":"3ab7a86c","CommandAdd~FastSale~SaleIndex":"7df717b5","CommandAdd":"31d6cfe0","CommandIndex~DocumentCreate~DocumentIndex~FastSale~Note~SaleIndex~payments~salesBySeller":"31d6cfe0","CommandIndex":"0814a253","CommandsReports~DocumentsReports~Inventories~InventoryHistories~salesBySeller":"31d6cfe0","salesBySeller":"31d6cfe0","DocumentCreate~FastSale~People~SaleIndex~payments":"31d6cfe0","FastSale":"31d6cfe0","Orders~OrdersCreate~SaleIndex":"31d6cfe0","SaleIndex":"0814a253","DocumentCreate":"31d6cfe0","payments":"31d6cfe0","DocumentIndex":"98cebd45","Note":"31d6cfe0","CommandZones":"3ab7a86c","CommandsReports":"31d6cfe0","DocumentsReports":"31d6cfe0","Inventories":"31d6cfe0","InventoryHistories":"31d6cfe0","Configurations":"3ab7a86c","Correlatives":"3ab7a86c","CulqiTokens":"31d6cfe0","DistributionAreas":"31d6cfe0","People":"3ab7a86c","Establishments":"3ab7a86c","Ingredients":"3ab7a86c","Items":"31d6cfe0","Login":"d7744c16","Movements":"31d6cfe0","Orders":"0814a253","OrdersCreate":"31d6cfe0","Permissions":"3ab7a86c","Recipes":"31d6cfe0","Reports":"31d6cfe0","Roles":"3ab7a86c","SalesReceivables":"31d6cfe0","Salons":"3ab7a86c","Summaries":"31d6cfe0","Tables":"3ab7a86c","UnitTypes":"3ab7a86c","Users":"0814a253","Voided":"98cebd45","Waiters":"3ab7a86c","cashes":"3ab7a86c","chunk-2d0e5e97":"31d6cfe0","deliveryPayment":"31d6cfe0","histories":"3ab7a86c","openings":"31d6cfe0","tasks":"3ab7a86c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
